import {
  ActionContext,
  ActionTree,
  GetterTree,
  MutationTree,
  Module
} from "vuex";
import questionFormUseCases from "../../../../domain/usecase/impl/question-form/questionFormUseCases";
import { RootState } from "../store";
import { QuestionForm } from "../../../../domain/entities/search-form/question_form";
import { BusinessRuleException, RepositoryException } from "../../../../domain/exceptions/exceptions";

class QuestionFormState {
  formExceptions: BusinessRuleException | null = null;
  evaluationQuestion: QuestionForm = new QuestionForm();
  total = 0;
  answered: Set<number> = new Set();
}

const state = new QuestionFormState();

const mutations: MutationTree<QuestionFormState> = {
  SET_EVALUATION_QUESTION(
    state: QuestionFormState,
    evaluationQuestion: QuestionForm
  ): void {
    state.evaluationQuestion = evaluationQuestion;
  },
  SET_ANSWERED(state, questionID: number) {
    state.answered.add(questionID);
  }
};

const actions: ActionTree<QuestionFormState, RootState> = {
  async responseQuestions(
    { commit }: ActionContext<QuestionFormState, RootState>,
    payload: {
      searchFormID: number;
      trainingID: number;
      questionID: number;
      questionForm: QuestionForm;
    }
  ) {
    try {
      await questionFormUseCases.responseQuestions(
        payload.searchFormID,
        payload.trainingID,
        payload.questionID,
        payload.questionForm
      );
      commit("SET_ANSWERED", payload.questionID);
    } catch (e) {
      if (
        e instanceof BusinessRuleException ||
        e instanceof RepositoryException
      ) {
        commit("SET_FORM_EXCEPTIONS", e);
        throw e;
      }

      throw e;
    }
  },

  async get(
    { commit }: ActionContext<QuestionFormState, RootState>,
    payload: { searchFormID: number; trainingID: number; page: number }
  ): Promise<void> {
    try {
      const response: QuestionForm = await questionFormUseCases.get(
        payload.searchFormID,
        payload.trainingID,
        payload.page
      );
      commit("SET_EVALUATION_QUESTION", response);
    } catch (e) {
      if (
        e instanceof BusinessRuleException ||
        e instanceof RepositoryException
      ) {
        commit("SET_FORM_EXCEPTIONS", e);
        throw e;
      }

      throw e;
    }
  },
};

const getters: GetterTree<QuestionFormState, RootState> = {
  evaluationQuestion: (state: QuestionFormState): QuestionForm =>
    state.evaluationQuestion,
  isComplete: (state) => (totalQuestions: number): boolean => {
    return state.answered.size >= totalQuestions;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} as Module<QuestionFormState, RootState>;
